import { AnyObject, Dictionary } from '@feedyou/utils'
import produce from 'immer'
import _ from 'lodash'

// Like _.groupBy, but for partitioning and nesting sub-sections of dictionary
// - see tests for a happy-day scenario :)
export const groupDictBy = <Dict extends AnyObject, Group extends keyof any>(
  dict: Dict,
  by: string | (<Key extends keyof Dict>(item: Dict[Key], key: Key) => string)
): Dictionary<Group, Partial<Dict>> => {
  return produce({} as AnyObject, draft => {
    Object.entries(dict).forEach(([key, value]) => {
      const group = _.isFunction(by) ? by(value, key) : value[by]

      if (!draft[group]) {
        draft[group] = {}
      }

      draft[group]![key] = value
    })
  })
}
